import React from "react";
import { Select, Tag } from "antd";
import type { SelectProps } from "antd";

type MultiSelectTagProps = {
  options: { label: string; value: string }[];
  value?: string[];
  onChange?: (value: string[]) => void;
  placeholder?: string;
  tagColor?: string;
  tagDisplay?: "label" | "value";
  mode?: "multiple" | "tags";
} & Omit<SelectProps<string[]>, "mode" | "options" | "value" | "onChange" | "placeholder" | "tagRender">;

const MultiSelectTag: React.FC<MultiSelectTagProps> = ({
  options,
  value,
  onChange,
  placeholder = "All",
  tagColor = "cyan",
  tagDisplay = "label",
  mode = "multiple",
  ...restProps
}) => {

  const isModeTag = mode === "tags";

  const tagRender: SelectProps["tagRender"] = (props) => {
    const { value, label, closable, onClose } = props;

    return (
      <Tag
        color={tagColor}
        closable={closable}
        onClose={onClose}
        style={{
          marginRight: 3,
          color: "var(--text-blue-300)",
          backgroundColor: "var(--text-blue-100)",
        }}
      >
        {tagDisplay === "value" ? value : label}
      </Tag>
    );
  };

  return (
    <Select
      mode={mode}
      allowClear
      showSearch
      value={value}
      onChange={onChange}
      tagRender={tagRender}
      placeholder={placeholder}
      filterOption={(input, option) => {
        const label = option?.label;
        return typeof label === "string" ? label.toLowerCase().includes(input.toLowerCase()) : false;
      }}
      options={options}
      tokenSeparators={isModeTag ? [","] : []}
      open={isModeTag ? false : undefined}
      {...(isModeTag ? { suffixIcon: null } : {})}
      {...restProps}
    />
  );
};

export default MultiSelectTag;
